<template>
    <v-data-table
        :headers="experimentMethodHeaders"
        :items="experimentMethods"
        item-key="id"
        class="elevation-1"
        :items-per-page="25"
    >
        <template v-slot:item.name="{ item }">
            <a v-if="item.descriptionUrl" :href="item.descriptionUrl" target="_blank" rel="noopener noreferrer">
                {{ item.name }}
            </a>
            <span v-else>{{ item.name }}</span>
        </template>
        <template v-slot:item.edit="{ item }">
            <v-row>
                <v-icon @click="editExperimentMethod(item)">$pencil</v-icon>
            </v-row>
        </template>
    </v-data-table>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useAuth } from "@/lib/ts/auth";
import { VDataTableHeader } from "@/vuetifyTypeFixes";
import { SavedExperimentMethod } from "@/services/experimentMethods/experimentMethodsAPI";

const { experimentMethods } = defineProps<{
    experimentMethods: SavedExperimentMethod[];
}>();

const emit = defineEmits<{
    (e: "editExperimentMethod", item: SavedExperimentMethod): void;
}>();

const auth = useAuth();

const userCanManageExperimentMethods = computed(() => {
    return auth.isAuthorized("ExperimentMethods:Manage");
});

const experimentMethodHeaders = ref<VDataTableHeader[]>([
    {
        title: "Code",
        value: "code",
        sortable: true,
        align: "start",
        width: "20%",
    },
    {
        title: "Name",
        value: "name",
        sortable: true,
        align: "start",
        width: "50%",
    },
    {
        title: "Platform",
        value: "platform.name",
        sortable: false,
        align: "start",
        width: "30%",
    },

]);

if (userCanManageExperimentMethods.value) {
    experimentMethodHeaders.value.push({
        title: "Edit",
        value: "edit",
        sortable: false,
        align: "start",
        width: "5%",
    });
}

function editExperimentMethod(item: SavedExperimentMethod) {
    emit("editExperimentMethod", item);
}

</script>
